import React, { createContext, useContext } from "react";

const MenuContext = createContext({
  userMenu: [],
});

export const MenuProvider = ({ value, children }) => {
  return <MenuContext.Provider value={value}>{children}</MenuContext.Provider>;
};

export const useMenuContext = () => useContext(MenuContext);
